import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Capabilities from "./pages/Capabilities";
import GovernmentContracting from "./pages/GovernmentContracting";
import IndustriesServed from "./pages/IndustriesServed";
import PastPerformance from "./pages/PastPerformance";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/capabilities" element={<Capabilities />} />
            <Route path="/government-contracting" element={<GovernmentContracting />} />
            <Route path="/industries-served" element={<IndustriesServed />} />
            <Route path="/past-performance" element={<PastPerformance />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
